module.exports = __webpack_public_path__ + "static/14.1_the_birth_of_christianity-8c67b0577b7d37fe1cdcdad76dae6287.pdf";